<template>
  <div class="popup-permission" @click="closePop()">
    <div class="popup-permission-inside">
      <div class="popup-permission-close">
        <button class="btn-x">Luk</button>
      </div>
      <div class="popup-permission-content">
        <div class="popup-permission-content-inside" v-if="whatPop == 'pop1'">
          <div v-html="compiledMarkdown(globalC.permission.popup1)">
          </div>
        </div>
        <div class="popup-permission-content-inside" v-if="whatPop == 'pop2'">
          <div v-html="compiledMarkdown(globalC.permission.popup2)"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Marked from 'marked';
import {mapGetters} from 'vuex';

export default {
  name: 'popupPermission',
  data () {
    return {
    }
  },
  computed: {
    ...mapGetters([
      'globalC',
      'whatPop'
    ])
  },
  mounted(){

  },
  methods:{
    compiledMarkdown(text) {
      return Marked(text, { sanitize: true })
    },
    closePop(){
      this.$store.state.global.whatPop = false;
    }
  }
}
</script>
<style lang="scss" scoped>
.btn-x{
  top:-24px;
  right:10px;
}
.popup-permission{
  position: fixed;
  z-index: 9999;
  background-color: rgba(0,0,0,0.5);
  width:100%;
  height:100%;
  top:0;
  overflow: auto;
  &-inside{
    max-width: 700px;
    margin: 40px auto;
    padding:0 20px;
    position: relative;
    animation: MoveUpDown 1s linear forward;
  }
  &-content{
    padding: 40px;
    background-color: #fff;
    border-radius: 16px;

    @media(max-width: 600px){
      padding: 20px;
    }
  }
}
@keyframes MoveUpDown {
  0%, 100% {
    transform: translateY(-100%);
  }
  50% {
    transform: translateY(0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modular/popup-permission.vue